import { GEnum } from '@/constants/enum.defination';
import { Serializable } from '@/models/core/serializable';
import { Student } from '@/models/student/student';
import i18n from '@/i18n';

export class EvaluatorCandidateStudent extends Student implements Serializable<EvaluatorCandidateStudent> {
  deserialize(input: any): EvaluatorCandidateStudent {
    super.deserialize(input);
    return this;
  }
  get displayName(): string {
    // eslint-disable-next-line
    return i18n.t('NUMBER_YEAR', {value: this.schoolClass.grade}).toString() + `${this.schoolClass.schoolClassName}　|　${this.fullName}`;
  }
}

export interface EvaluatorCandidateStudentRequest {
  evalSettingID: number;
  examineeStudentID: number;
  evaluatorScopeType: GEnum.EvaluatorScopeType;
}
